var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main-view',[_c('timelapse-viewer',{attrs:{"url":"/timelapse/herring/300x/2019/playlist.m3u8"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }